"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntroOfferButton = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("../Cart/CartContext");
var IntroOfferButton = function (_a) {
    var discount = _a.discount, discountCopy = _a.discountCopy;
    var _b = (0, hooks_1.useContext)(CartContext_1.default), introOffer = _b.introOffer, setIntroOffer = _b.setIntroOffer;
    //helper function to fetch shopify discount url and apply code
    var applyDiscount = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("https://account.opositiv.com/discount/".concat(discount))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Network response was not OK');
                    }
                    setIntroOffer(true);
                    window.sessionStorage.setItem('intro-offer', 'true');
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error applying discount code in cart:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // helper function to handle user click, apply shopify discount code, and update context
    var handleClick = function () {
        applyDiscount();
    };
    //if user previously checked the box then keep it checked and re apply the discount code
    (0, hooks_1.useEffect)(function () {
        if (window.sessionStorage.getItem('intro-offer') == 'true') {
            applyDiscount();
        }
    }, []);
    return ((0, preact_1.h)("div", { class: "cart-section__summary-intro-offer-container" },
        (0, preact_1.h)("div", { class: "cart-section__summary-intro-offer" },
            (0, preact_1.h)("div", { class: "cart-section__summary-intro-offer-box" },
                (0, preact_1.h)("input", { checked: introOffer, className: "cart-section__summary-intro-offer-check", disabled: introOffer, id: "introOffer", onClick: handleClick, type: "checkbox" }),
                (0, preact_1.h)("label", { for: "introOffer", class: "cart-section__summary-intro-offer-text" },
                    "Apply ",
                    discountCopy,
                    " ",
                    (0, preact_1.h)("p", null, "to your order")))),
        introOffer && ((0, preact_1.h)("p", { class: "cart-section__summary-intro-offer-info" }, "*Coupon applied at checkout"))));
};
exports.IntroOfferButton = IntroOfferButton;
